import { createFileRoute } from "@tanstack/react-router";
import { SheetHud } from "@/components/Sheets";

function RouteComponent() {
  const { sheetId } = Route.useParams();
  return <SheetHud key={sheetId} sheetId={sheetId} />;
}

export const Route = createFileRoute("/_authenticated/financials/sheets/$sheetId")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
